export enum RouteName {
  BusModule = 'bus-module',
  BusModuleAllocation = 'bus-module-allocation',
  BusModuleAllocations = 'bus-module-allocations',
  BusModuleRoutes = 'bus-module-routes',
  BusModuleSubsystems = 'bus-module-subsystems',
  BusTimetables = 'bus-timetables',
  ChooseContext = 'choose-context',
  ClientCommunication = 'client-communication',
  ClientCommunicationTemplates = 'client-communication-templates',
  ClientCommunicationRules = 'client-communication-rules',
  ClientCommunicationMessages = 'client-communication-messages',
  CreateRole = 'create-role',
  DispatcherScreen = 'dispatcher-screen',
  DriverRegisterToken = 'driver-register-token',
  Drivers = 'drivers',
  DriverSources = 'driver-sources',
  EventDashboard = 'event-dashboard',
  Events = 'events',
  LivePanel = 'live-panel',
  Locations = 'locations',
  PassengerDemands = 'passenger-demands',
  PassengerEvent = 'passenger-event',
  PassengerEvents = 'passenger-events',
  PassengerPortal = 'passenger-portal',
  PasswordRecovery = 'password-recovery',
  Role = 'role',
  Roles = 'roles',
  Session = 'session',
  ShareQrToken = 'share-qr-token',
  TmmHub = 'tmm-hub',
  Vehicles = 'vehicles',
  VehicleSources = 'vehicle-sources',
  OrganizationClientCommunicationTemplates = 'organization-client-communication-templates',
  OrganizationUsers = 'organization-users',
}
